
import axios from 'axios';

import logger from '../app/logger';

declare var config: Object;


export const fetchAxiosApi = async (url, { method, headers, body, config: confg, timeout = 20000, responseType, signal } = {}) => {

    let urlConfig;

    if (confg) {
        urlConfig = `${confg.API_URL_PREFIX}${confg.API_VERSION_PREFIX}${url}`;
    } else if (typeof config !== 'undefined' && config?.API_URL_PREFIX) {
        urlConfig = `${config.API_URL_PREFIX}${config.API_VERSION_PREFIX}${url}`;
    } else {
        urlConfig = url;
    }

    const res = (/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%.+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g).test(url);

    try {
        const axiosConfig = {
            url: res ? url : urlConfig,
            timeout,
            method,
            headers,
            data: body
        };

        if (responseType) {
            axiosConfig.responseType = responseType;
        }

        if (signal) {
            axiosConfig.signal = signal;
        }

        const data = await axios(axiosConfig);

        return data.data;
    } catch (e) {
        // Without the endpoint and status these lines are undiagnosable - a bare 'status code 403' says nothing
        // about which call was rejected. The query string is left out on purpose: it can carry tokens.
        const requestUrl = res ? url : urlConfig;
        const endpoint = `${requestUrl}`.split('?')[0];

        logger.warn(`Axios request failed: ${e.message} [${method || 'GET'} ${endpoint}`
            + `${e.response?.status ? ` -> ${e.response.status}` : ''}]`);

        return e;
    }
};

/**
 * Returns participant ID of the owner of a virtual screenshare participant.
 *
 * A duplicate of the function of the same name in `base/participants/functions.js`; both are live and
 * both must tolerate a missing ID for the reason documented there.
 *
 * @param {string} [id] - The ID of the virtual screenshare participant.
 * @private
 * @returns {(string|undefined)}
 */
export function getVirtualScreenshareParticipantOwnerId(id) {
    if (typeof id !== 'string') {
        return undefined;
    }

    if (id.endsWith('-screenshare')) {
        return id.replace('-screenshare', '');
    }

    // Source names follow the format: endpointId-v0, endpointId-a1, etc.
    // Strip the trailing -{v|a}{digit(s)} suffix to get the full endpoint ID,
    // which may itself contain hyphens (e.g. UUID-style IDs).
    return id.replace(/-[va]\d+$/, '');
}


export const getScreenShareParticipantID = ownerId => {
    if (typeof ownerId !== 'string') {
        return undefined;
    }

    return getVirtualScreenshareParticipantOwnerId(ownerId.split('_')[0]);
};
